import { useEffect, useState } from 'react'
import { toast } from '@sales-center/components'

import { isAPIError } from '@user/store/services/crud'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import { getAllCustomFields } from '../api'

export function useGetCustomFieldsOnMount() {
  const [loading, setLoading] = useState(false)

  const dispatch = useAppDispatch()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setLoading(true)
      const response = await dispatch(getAllCustomFields())

      if (getAllCustomFields.rejected.match(response)) {
        if (isAPIError(response.payload)) {
          toast.error(response.payload.Message)
        } else {
          toast.error('Failed to load Custom Fields')
        }
      }

      if (mounted) setLoading(false)
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return loading
}
